<template>
  <div id="administracion">
    <div class="col-md-12 container-fluid bg-light">
      <div class="row justify-content-center">
        <div class="col-md-12" id="col-nav-admin">
          <ul class="nav nav-tabs" id="nav-tab" role="tablist">
            <li class="nav-item">
              <router-link
                id="mrc-tab"
                to="/clientes"
                class="nav-link nav-link-admin pt-2 pb-3"
                active-class="active"
                data-toggle="tab"
                role="tab"
                aria-controls="mrc"
                aria-selected="true"
              >
                Clientes
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                id="mrp-tab"
                to="/procesos"
                class="nav-link nav-link-admin pt-2 pb-3"
                active-class="active"
                data-toggle="tab"
                role="tab"
                aria-controls="mrp"
                aria-selected="false"
              >
                Procesos
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                id="mrpe-tab"
                to="/peligros"
                class="nav-link nav-link-admin pt-2 pb-3"
                active-class="active"
                data-toggle="tab"
                role="tab"
                aria-controls="mrpe"
                aria-selected="false"
              >
                Peligros
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                id="mrep-tab"
                to="/EfectosPosibles"
                class="nav-link nav-link-admin pt-2 pb-3"
                active-class="active"
                data-toggle="tab"
                role="tab"
                aria-controls="mrep"
                aria-selected="false"
              >
                Efectos Posibles
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                id="mrce-tab"
                to="/controlExistente"
                class="nav-link nav-link-admin pt-2 pb-3"
                active-class="active"
                data-toggle="tab"
                role="tab"
                aria-controls="mrce"
                aria-selected="false"
              >
                Control Existente o Medida de Intervención
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                id="mru-tab"
                to="/usuario"
                class="nav-link nav-link-admin pt-2 pb-3"
                active-class="active"
                data-toggle="tab"
                role="tab"
                aria-controls="mru"
                aria-selected="false"
              >
                Usuarios
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                id="mrr-tab"
                to="/regionales"
                class="nav-link nav-link-admin pt-2 pb-3"
                active-class="active"
                data-toggle="tab"
                role="tab"
                aria-controls="mrr"
                aria-selected="false"
              >
                Regionales
              </router-link>
            </li>
            <li class="nav-item">
              <router-link
                id="an-tab"
                to="/administracion/novedades"
                class="nav-link nav-link-admin pt-2 pb-3"
                active-class="active"
                data-toggle="tab"
                role="tab"
                aria-controls="mrr"
                aria-selected="false"
              >
                Novedades
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-md-12 container-fluid mt-4">
      <div class="pl-md-1 pr-md-1 pl-1 pr-1">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "administracion",
  data() {
    return {
      clientes: false,
      proceso: false,
      registro_peligro: false,
      descripcion_peligro: false,
      registro_efectos_posibles: false,
      çontrol_medida: false,
      registro_usuario: false,
      registro_regionales: false,
    };
  },
  created() {
    if (!this.$store.state.user_auth) {
      this.$router.replace("/");
      return;
    }
  },
  methods: {},
};
</script>